import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Tag } from '@qaroni-app/tags/types/tag';
import { TagsMenuUpdateDialogForm } from './tags-menu-update-dialog.form';

@Component({
  selector: 'qaroni-tags-menu-update-dialog',
  templateUrl: './tags-menu-update-dialog.component.html',
  styleUrls: ['./tags-menu-update-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TagsMenuUpdateDialogComponent
  extends TagsMenuUpdateDialogForm
  implements OnInit
{
  tag = inject<Tag>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<TagsMenuUpdateDialogComponent>>(MatDialogRef);

  private isSubmitting = false;

  ngOnInit(): void {
    this.populateUpdateTagForm(this.tag);
  }

  get validatedForm(): boolean {
    return this.dirtyValidForm && !this.isSubmitting;
  }

  public onSubmit(): void {
    if (this.validatedForm) {
      this.isSubmitting = true;

      this.dialogRef.close(this.form.value);
    }
  }

  public onCancelClick(): void {
    this.dialogRef.close(null);
  }
}
